module.exports = __webpack_public_path__ + "img/dynamic-26.adf902b5.png";